// src/Dashboard/pages/user/Galleries/components/GallerySkeleton.jsx

import React from "react";

export default function GallerySkeleton() {
  return (
    <div className="overflow-hidden rounded-[24px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-950">
      <div
        className="animate-pulse bg-slate-200 dark:bg-slate-800"
        style={{ aspectRatio: "16 / 9" }}
      />

      <div className="space-y-3 p-4">
        <div className="h-4 w-2/3 animate-pulse rounded bg-slate-200 dark:bg-slate-800" />
        <div className="h-3 w-full animate-pulse rounded bg-slate-200 dark:bg-slate-800" />
        <div className="h-3 w-5/6 animate-pulse rounded bg-slate-200 dark:bg-slate-800" />
        <div className="h-10 w-36 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800" />
      </div>
    </div>
  );
}